import {PlusIcon} from '@web/assets/icons';
import {Tooltip} from 'antd';
import AddAction from '../AddAction';

export const AddActionButton = () => {
  return <div style={{position: "absolute", bottom: "-36px", width: "90%", zIndex: 1}}>
    <div style={{width: "100%", height: 60}} />
    <Tooltip
      title={<div><AddAction /></div>}
      trigger={["click"]}
    >
      <div className="space space-center-y space-center-x rounded" style={{padding: "10px 0", backgroundColor: "#0e161f", border: "dashed 1px rgba(255, 255, 255, 0.1)"}}><PlusIcon /> Add step</div>
    </Tooltip>
  </div>
}
